import { version } from '../../package.json';

export const environment: {
  production: boolean;
  apiUrl: string;
  newsletterLink: string;
  resultDetailUrl: string;
  translationVersion: string;
  appVersion: string;
  sentryDsn: string;
  googleAnalyticsId?: string;
  matomo: { siteId: number; trackerUrl: string };
  chatbot?: {
    enabled: boolean;
    embedScriptUrl: string;
  };
} = {
  production: false,
  apiUrl: 'https://dev-api.amuvee.de',
  translationVersion: '1.2.1',
  appVersion: version,
  sentryDsn: 'https://8b03ae1eff5845b89704503417804d25@errors-dev.amuvee.de/2',
  newsletterLink: 'https://seu2.cleverreach.com/f/372816-377089/wcs/',
  resultDetailUrl: 'https://dev.amuvee.de/#/result/{vid}/{rid}',
  googleAnalyticsId: undefined,
  matomo: { siteId: 1, trackerUrl: 'https://matomo-dev.amuvee.de' },
  chatbot: {
    enabled: true,
    embedScriptUrl: 'https://staging-rk.amuvee.de/embed/widget.js',
  },
};
